import { render, staticRenderFns } from "./sales-product-definition.vue?vue&type=template&id=ef506b54&scoped=true&"
import script from "./sales-product-definition.vue?vue&type=script&lang=js&"
export * from "./sales-product-definition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef506b54",
  null
  
)

export default component.exports